import { render } from "./rootPayment.vue?vue&type=template&id=316bb990&scoped=true"
const script = {}

import "./rootPayment.vue?vue&type=style&index=0&id=316bb990&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316bb990"]])

export default __exports__